import { useSession } from '@/features/auth/use-session'
import { EmptyState } from '@/shared/components/data'
import { useT } from '@/shared/i18n'

import { DueSoonView } from './DueSoonView'

/** `/me/tasks` — lo mismo, acotado a lo mío, de todas las empresas. */
export function MyTasksPage() {
  const { me } = useSession()
  const t = useT()

  if (!me) {
    return (
      <div className="p-4">
        <EmptyState
          title={t('dueSoon.mine.noSession.title')}
          description={t('dueSoon.mine.noSession.description')}
        />
      </div>
    )
  }

  return (
    <DueSoonView
      title={t('nav.myTasks')}
      description={t('dueSoon.mine.description')}
      lockedAssigneeId={me.id}
      defaultGroupBy="proyecto"
    />
  )
}
